
export class LaunchesDate {

    name: string;
    y: string;
    color: string;

    constructor() {
        this.name = "";
        this.y = "";
        this.color = ""
    }

}

